import { render, staticRenderFns } from "./payment-value-card.vue?vue&type=template&id=66653662&class=spacer-bottom-xl&"
import script from "./payment-value-card.vue?vue&type=script&lang=js&"
export * from "./payment-value-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports